import { Component } from '@angular/core';
import { SecurityData } from '../security-data';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './forbidden.component.html',
  imports: [TranslatePipe]
})
export class ForbiddenComponent {
  constructor(public securityData: SecurityData) {}
}
